import { BlockShortcutMenu } from 'articleEditor/plugins';
import { PLATE_ID } from 'lib-knowledge-document-structure';
import { PlateContent } from 'lib-knowledge-document-structure/plate/common';
import { RenderPlaceholderProps } from 'lib-knowledge-document-structure/slate/react';
import {
  ClipboardEvent as ReactClipboardEvent,
  DragEvent as ReactDragEvent,
  useCallback,
} from 'react';

import { ContextMenu } from '../contextMenu';
import { DragManager } from '../dragManager';
import { LinkMenu } from '../linkMenu';

import s from './editor.module.scss';

type EditorProps = {
  onDrop?: (dragEvent: ReactDragEvent<HTMLElement>) => void;
  onPaste?: (clipboardEvent: ReactClipboardEvent<HTMLElement>) => void;
};

export function Editor({ onDrop, onPaste }: EditorProps = {}): JSX.Element {
  const renderPlaceholder = useCallback(
    ({ attributes, children }: RenderPlaceholderProps): JSX.Element => (
      <Placeholder attributes={attributes}>{children}</Placeholder>
    ),
    [],
  );
  return (
    <DragManager>
      <PlateContent
        // This is needed, as Plate tries to use Symbol by default and it causes a DOM error.
        id={PLATE_ID}
        className={s['editor']}
        placeholder="Add content..."
        renderPlaceholder={renderPlaceholder}
        onDrop={onDrop}
        onPaste={onPaste}
      />
      <ContextMenu />
      <BlockShortcutMenu />
      <LinkMenu />
    </DragManager>
  );
}

const Placeholder = ({ attributes, children }: RenderPlaceholderProps) => (
  <div
    {...attributes}
    className={s['placeholder']}
    // Override plates opacity
    style={{
      ...attributes.style,
      opacity: 0.5,
    }}
  >
    {children}
  </div>
);
